<template>
  <div style="position: relative; z-index: 100">
    <v-app-bar color="primary" class="mb-3 pt-2 pb-2" dark app height="auto">
      <v-app-bar-nav-icon
        @click.stop="$store.state.navigation = !$store.state.navigation"
      ></v-app-bar-nav-icon>
      <v-toolbar-title style="margin-right: 40px">
        <translate>Tender Browse</translate>
      </v-toolbar-title>
      <!-- <v-menu
                fixed
                value="true"
                max-height="200"
                max-width="300"
                z-index="9999"
            >
                <v-list>
                    <v-list-item>fewfefewf</v-list-item>
                </v-list>
            </v-menu> -->
      <div style="width: 40%; position: relative" id="searchMenu">
        <v-text-field
          ref="searchInput"
          prepend-inner-icon="search"
          @focus="showMenu = true"
          @blur="showMenu = false"
          light
          :placeholder="!searchPrefix ? $gettext('Search') : ''"
          @click:prepend-inner.prevent="searchTendersByChosenType(null)"
          @keydown.enter.prevent="searchTendersByChosenType(null)"
          :append-icon="searchText || searchPrefix ? 'close' : ''"
          @click:append="clearSearch"
          v-model="searchText"
          :prefix="searchPrefix"
          solo
          style="color: gray"
          height="10"
          hide-details
          single-line
        ></v-text-field>
        <v-menu
          v-model="showMenu"
          bottom
          absolute
          offset-y
          :close-on-click="false"
          attach="#searchMenu"
          nudge-bottom="50"
          z-index="9999"
          max-height="300"
          max-width="400"
        >
          <v-list v-if="!searchPrefix">
            <v-list-item
              v-for="(item, index) in sortSearchElements"
              :key="index"
              @mousedown.prevent="searchTendersByFilters(item)"
              style="cursor: pointer"
            >
              <v-list-item-title>{{ `${item.title}: ${searchText}` }}</v-list-item-title>
            </v-list-item>
          </v-list>
          <v-list v-else-if="searchPrefix && itemsSearchByType.length">
            <v-list-item
              v-for="(item, index) in itemsSearchByType"
              :key="index"
              @mousedown.prevent="searchTendersByChosenType(item)"
              style="cursor: pointer"
            >
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <v-spacer></v-spacer>
    </v-app-bar>
  </div>
</template>

<script>
import Search from '@/utils/Search'
import elementsForSearch from '@/assets/js/search/search'
export default {
  name: 'AppBar',

  data() {
    return {
      showSearchTypes: [],
      showMenu: false,
      searchText: '',
      itemsSearch: elementsForSearch,
      currentItemSearch: false,
      searchTypeOptions: [],
      itemsSearchByType: [],
      searchPrefix: '',
    }
  },

  created() {
    this.$gettext('Search')

    this.handleSearchQuery()
  },

  watch: {
    $route() {
      this.handleSearchQuery()
      if (
        !this.$route.query ||
        (this.$route.query && !this.$route.query.searchPhrase && !this.$route.query.searchText)
      ) {
        this.$store.commit('search/discardSearch')
      }
    },
    showSearch(newValue) {
      this.showMenu = !!newValue
    },
    searchText(newValue) {
      //this watcher is used for defining array of items (this.itemsSearch) which are in the form of object
      //and will be shown in the search menu so that we can choose one to perform search
      if (newValue.length >= 1 && !this.searchPrefix) {
        this.showMenu = true
        this.itemsSearch = elementsForSearch
        let newArrayOfTypes = Search.filter(newValue)
        if (newArrayOfTypes.length !== 0) {
          let filteredSearchBox = []
          newArrayOfTypes.forEach((phrase) => {
            const filterObj = this.$_.findWhere(this.itemsSearch, {
              type: phrase,
            })
            if (filterObj !== undefined) {
              filteredSearchBox.push(filterObj)
            }
          })
          this.itemsSearch = [...filteredSearchBox]
        }
      } else if (this.searchPrefix) {
        this.getItemsSearchByType(newValue)
      } else {
        this.filteredTenders = []
        if (newValue.length === 0) {
          this.searchPrefix = ''
        }
        this.itemsSearch = elementsForSearch
      }
    },
    searchBox(open) {
      this.searchText = ''
      if (open) {
        this.showSearch = true
        // this.$store.commit('search/setSearchMeta', {
        //     type: '',
        //     text: '',
        //     title: ''
        // })
        this.$nextTick(() => this.$refs.searchInput.focus())
      } else {
        this.showSearch = false
      }
    },
    searchTendersByChosenType(item) {
      if (item && this.itemsSearchByType.length) {
        this.searchText = item.text
        this.$nextTick(() => {
          this.searchTendersByFilters(item)
        })
      } else {
        this.searchTendersByFilters(this.currentItemSearch)
      }
    },
    closeSearch() {
      this.searchPrefix = ''
      this.showSearch = false
      this.itemsSearchByType = []
      this.currentItemSearch = ''
      this.filteredTenders = false
    },
    discardSearchResult(e) {
      this.searchPrefix = ''
      this.filteredTenders = false
      this.showSearch = false

      this.$store.commit('search/setSearchMeta', {
        type: '',
        text: '',
        title: '',
      })

      if (e.which === 2) {
        window.open(`${window.location.origin}/#/tenders`, '_blank')
      }
    },
    exitFromSearch() {
      if (!this.showMenu) {
        this.showSearch = false
      }
    },
    getItemsSearchByType(newValue) {
      //this function is used for finding array of possible options
      //when search Prefix is set
      this.currentItemSearch = elementsForSearch.find((el) => {
        return el.title.toLowerCase().includes(this.searchPrefix.toLowerCase().slice(0, -2))
      })

      //all possible options for current search type
      this.searchTypeOptions = Search.filterByType(this.currentItemSearch.type)

      //filtered options while entering some data
      this.itemsSearchByType = this.searchTypeOptions.filter((el) => el.startsWith(newValue))

      //formatted options suited for performing correct search
      this.itemsSearchByType = this.itemsSearchByType.map((el) => {
        return {
          title: this.currentItemSearch.title,
          type: this.currentItemSearch.type,
          text: el,
        }
      })
    },
  },

  computed: {
    sortSearchElements() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.itemsSearch.sort(function (a, b) {
        return b.priority - a.priority
      })
    },
  },
  methods: {
    handleSearchQuery() {
      if (this.$route.query && this.$route.query.searchPhrase) {
        this.searchText = this.$route.query.searchText
        this.searchPrefix = this.$route.query.searchPhrase

        this.showSearch = true
        this.showMenu = false
      } else {
        this.searchText = ''
        this.searchPrefix = ''

        this.showSearch = true
        this.showMenu = false
      }
      // else if (this.$store.state.search.meta.text) {
      //     const item = {
      //         type: this.$store.state.search.meta.type,
      //         title: this.$store.state.search.meta.title
      //     }
      //     this.showSearch = true
      //     this.searchText = this.$store.state.search.meta.text
      //     this.$nextTick(() => {
      //         this.searchTendersByFilters(item)
      //     })
      // }
    },
    searchTendersByFilters(item) {
      if (!item) {
        return
      } else if (!this.searchText.length) {
        this.searchPrefix = item.title + ': '
        this.itemsSearchByType = []
        this.getItemsSearchByType('')
      } else {
        if (this.searchText.length >= 3) {
          this.searchPrefix = item.title + ': '

          this.showMenu = false

          if (item.type === 'date') {
            this.searchText = this.$moment(this.searchText).format('YYYY-MM-DD')
          }

          this.$store.commit('search/setSearchMeta', {
            type: item.type,
            text: this.searchText,
            title: item.title,
          })

          const searchToRequest = {
            searchPhrase: item.title,
            searchType: item.type,
            searchText: this.searchText,
          }

          this.$router.push({
            name: 'prozorrotenders',
            query: { ...searchToRequest },
            props: true,
          })

          this.$nextTick(async () => {
            if (this.$route.name.includes('prozorro')) {
              this.$store.dispatch('search/getFilteredTendersBySearch', {
                type: item.type,
                text: this.searchText,
              })
            }
          })
        }
      }
    },
    // searchTendersByFilters(item) {
    //     if (!item) return
    //     if (!this.searchText && !this.searchPrefix) {
    //         //if there is no entered value so we just set prefix to search input
    //         this.searchPrefix = item.title + ': '
    //     } else {

    //     }
    // },
    searchTendersByChosenType(item) {
      if (item && this.itemsSearchByType.length) {
        this.searchText = item.text
        this.$nextTick(() => {
          this.searchTendersByFilters(item)
        })
      } else {
        this.searchTendersByFilters(this.currentItemSearch)
      }
    },
    getItemsSearchByType(newValue) {
      this.currentItemSearch = elementsForSearch.find((el) => {
        return el.title.toLowerCase().includes(this.searchPrefix.toLowerCase().slice(0, -2))
      })

      this.searchTypeOptions = Search.filterByType(this.currentItemSearch.type)

      this.itemsSearchByType = this.searchTypeOptions.filter((el) => el.startsWith(newValue))

      this.itemsSearchByType = this.itemsSearchByType.map((el) => {
        return {
          title: this.currentItemSearch.title,
          type: this.currentItemSearch.type,
          text: el,
        }
      })
    },
    clearSearch() {
      this.searchPrefix = ''
      this.itemsSearchByType = []
      this.currentItemSearch = ''
      this.searchText = ''
    },
  },
}
</script>

<style scoped></style>
